import React, { useState } from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import { useDocTitle } from '../hooks/CustomHook';
import axios from 'axios';
import Notiflix from 'notiflix';
import config from '../config/config';
const DemoProduct = (props) => {
    const app_logo = config.appLogoUrl;
    useDocTitle('江西族迹 | 产品合作')

    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [message, setMessage] = useState('')
    const [company, setCompany] = useState('')
    const [errors, setErrors] = useState([])

    const clearErrors = () => {
        setErrors([])
    }

    const clearInput = () => {
        setFirstName('')
        setLastName('')
        setEmail('')
        setPhone('')
        setMessage('')
        setCompany('')
    }

    function sendEmail(e) {
        e.preventDefault();
        document.getElementById('submitBtn').disabled = true;
        document.getElementById('submitBtn').innerHTML = '提交中...';
        let fData = new FormData();
        fData.append('first_name', firstName)
        fData.append('last_name', lastName)
        fData.append('email', email)
        fData.append('phone_number', phone)
        fData.append('message', message)
        fData.append('company', company)
        fData.append('product', '族语APP')

        axios({
            method: "post",
            url: process.env.REACT_APP_DEMO_REQUEST_API,
            data: fData,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(function (response) {
                document.getElementById('submitBtn').disabled = false;
                document.getElementById('submitBtn').innerHTML = '提交申请';
                clearInput()
                Notiflix.Report.success(
                    '提交成功',
                    response.data.message,
                    '确定',
                );
            })
            .catch(function (error) {
                document.getElementById('submitBtn').disabled = false;
                document.getElementById('submitBtn').innerHTML = '提交申请';
                const { response } = error;
                if (response.status === 500) {
                    Notiflix.Report.failure(
                        '发生错误',
                        response.data.message,
                        '确定',
                    );
                }
                if (response.data.errors !== null) {
                    setErrors(response.data.errors)
                }
            });
    }

    return (
        <>
            <NavBar />
            <div id='demo' className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 py-12 lg:py-24">
                <div className="container mx-auto px-4 lg:px-8">
                    {/* 页面标题 */}
                    <div className="text-center mb-12">
                        <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">产品合作</h1>
                        <div className="w-20 h-1 bg-blue-600 mx-auto mb-6 rounded-full"></div>
                        <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                            体验族语APP，开启家族文化数字化传承之旅
                        </p>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
                        {/* 联系信息卡片 */}
                        <div
                            className="lg:col-span-1 bg-gradient-to-br from-blue-600 to-blue-800 text-white rounded-2xl shadow-2xl p-8 lg:p-10"
                        >
                            <div className="mb-8">
                                <div className="flex items-center mb-6">
                                    <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mr-4">
                                        <img src={app_logo} alt="族语APP" />
                                    </div>

                                    <div>
                                        <h2 className="text-2xl font-bold">江西族迹</h2>
                                        <p className="text-blue-200 text-sm">家族文化数字化专家</p>
                                    </div>
                                </div>
                                <p className="text-blue-100 leading-relaxed">
                                    专注于家族文化传承的数字化解决方案，让每个家族的故事得以永久保存和传承
                                </p>
                            </div>

                            {/* 产品特色 */}
                            <div className="mb-8">
                                <h3 className="font-semibold text-lg mb-4">族语APP特色</h3>
                                <div className="space-y-3">
                                    {[
                                        "家族树智能构建",
                                        "家族故事数字化保存",
                                        "亲情联系便捷化",
                                        "文化传承现代化",
                                        "隐私安全有保障"
                                    ].map((feature, index) => (
                                        <div key={index} className="flex items-center">
                                            <div className="w-2 h-2 bg-white rounded-full mr-3"></div>
                                            <span className="text-blue-200 text-sm">{feature}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* 联系信息 */}
                            <div className="space-y-6">
                                {/* 地址 */}
                                <div className="flex items-start group">
                                    <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center mr-4 mt-1 group-hover:scale-110 transition-transform duration-300">
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-lg mb-1">办公地址</h3>
                                        <p className="text-blue-200 text-sm">江西省南昌市红谷滩区</p>
                                        <p className="text-blue-200 text-sm">红谷中大道998号绿地中央广场</p>
                                        <p className="text-blue-200 text-sm">A1#办公室5206-2室</p>
                                    </div>
                                </div>

                                {/* 电话 */}
                                <div className="flex items-center group">
                                    <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300">
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-lg mb-1">联系电话</h3>
                                        <a href="tel:+8613812345678" className="text-blue-200 hover:text-white transition-colors duration-300 text-sm">
                                            4001818105
                                        </a>
                                    </div>
                                </div>

                                {/* 邮箱 */}
                                <div className="flex items-center group">
                                    <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300">
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-lg mb-1">电子邮箱</h3>
                                        <a href="mailto:ryan@sayfamily.com" className="text-blue-200 hover:text-white transition-colors duration-300 text-sm">
                                            ryan@sayfamily.com
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 产品展示和表单 */}
                        <div
                            className="lg:col-span-2 bg-white rounded-2xl shadow-2xl p-8 lg:p-10"
                        >
                            <form onSubmit={sendEmail} id="demoProductForm">
                                <div className="mb-8">
                                    <h2 className="text-3xl font-bold text-gray-800 mb-2">申请族语APP演示</h2>
                                    <p className="text-gray-600">体验创新的家族文化传承平台，开启数字化寻根之旅</p>
                                </div>

                                {/* 产品展示 */}
                                <div className="mb-8">
                                    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-6 border border-blue-200">
                                        <div className="flex items-center mb-4">
                                            <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center mr-4">
                                                <img src={app_logo} alt="族语APP" />
                                            </div>
                                            <div>
                                                <h3 className="text-2xl font-bold text-gray-800">族语APP</h3>
                                                <p className="text-gray-600">家族文化传承数字化平台</p>
                                            </div>
                                        </div>
                                        <p className="text-gray-700 mb-4">
                                            族语APP是一款专注于家族文化传承的移动应用，通过数字化技术帮助家族记录历史、联系亲情、传承文化，让家族的记忆永不消逝。
                                        </p>
                                        <div className="grid grid-cols-2 gap-4 text-sm">
                                            <div className="flex items-center">
                                                <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                                                <span>家族树构建</span>
                                            </div>
                                            <div className="flex items-center">
                                                <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                                                <span>故事记录</span>
                                            </div>
                                            <div className="flex items-center">
                                                <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                                                <span>亲情社交</span>
                                            </div>
                                            <div className="flex items-center">
                                                <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                                                <span>文化传承</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* 联系信息表单 */}
                                <div className="mb-8">
                                    <h3 className="text-xl font-semibold text-gray-800 mb-6">联系信息</h3>
                                    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                                        {/* 姓氏 */}
                                        <div>
                                            <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="first_name">
                                                姓氏 *
                                            </label>
                                            <input
                                                id="first_name"
                                                name="first_name"
                                                className="w-full bg-gray-50 border border-gray-200 text-gray-900 rounded-xl p-4 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                                type="text"
                                                placeholder="请输入您的姓氏"
                                                value={firstName}
                                                onChange={(e) => setFirstName(e.target.value)}
                                                onKeyUp={clearErrors}
                                            />
                                            {errors.first_name &&
                                                <p className="text-red-500 text-sm mt-2">{errors.first_name}</p>
                                            }
                                        </div>

                                        {/* 名字 */}
                                        <div>
                                            <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="last_name">
                                                名字 *
                                            </label>
                                            <input
                                                id="last_name"
                                                name="last_name"
                                                className="w-full bg-gray-50 border border-gray-200 text-gray-900 rounded-xl p-4 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                                type="text"
                                                placeholder="请输入您的名字"
                                                value={lastName}
                                                onChange={(e) => setLastName(e.target.value)}
                                                onKeyUp={clearErrors}
                                            />
                                            {errors.last_name &&
                                                <p className="text-red-500 text-sm mt-2">{errors.last_name}</p>
                                            }
                                        </div>

                                        {/* 公司/家族 */}
                                        <div>
                                            <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="company">
                                                公司/家族名称
                                            </label>
                                            <input
                                                id="company"
                                                name="company"
                                                className="w-full bg-gray-50 border border-gray-200 text-gray-900 rounded-xl p-4 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                                type="text"
                                                placeholder="请输入公司或家族名称"
                                                value={company}
                                                onChange={(e) => setCompany(e.target.value)}
                                                onKeyUp={clearErrors}
                                            />
                                        </div>

                                        {/* 邮箱 */}
                                        <div>
                                            <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="email">
                                                电子邮箱 *
                                            </label>
                                            <input
                                                id="email"
                                                name="email"
                                                className="w-full bg-gray-50 border border-gray-200 text-gray-900 rounded-xl p-4 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                                type="email"
                                                placeholder="请输入您的邮箱"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                onKeyUp={clearErrors}
                                            />
                                            {errors.email &&
                                                <p className="text-red-500 text-sm mt-2">{errors.email}</p>
                                            }
                                        </div>

                                        {/* 电话 */}
                                        <div>
                                            <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="phone_number">
                                                联系电话 *
                                            </label>
                                            <input
                                                id="phone_number"
                                                name="phone_number"
                                                className="w-full bg-gray-50 border border-gray-200 text-gray-900 rounded-xl p-4 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                                type="tel"
                                                placeholder="请输入您的电话"
                                                value={phone}
                                                onChange={(e) => setPhone(e.target.value)}
                                                onKeyUp={clearErrors}
                                            />
                                            {errors.phone_number &&
                                                <p className="text-red-500 text-sm mt-2">{errors.phone_number}</p>
                                            }
                                        </div>
                                    </div>
                                </div>

                                {/* 消息内容 */}
                                <div className="mb-8">
                                    <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="message">
                                        具体需求描述 *
                                    </label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        placeholder="请描述您对族语APP的具体需求，例如：家族规模、期望功能、使用场景等..."
                                        className="w-full h-40 bg-gray-50 border border-gray-200 text-gray-900 rounded-xl p-4 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 resize-none"
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        onKeyUp={clearErrors}
                                    ></textarea>
                                    {errors.message &&
                                        <p className="text-red-500 text-sm mt-2">{errors.message}</p>
                                    }
                                </div>

                                {/* 提交按钮 */}
                                <div className="flex justify-end">
                                    <button
                                        type="submit"
                                        id="submitBtn"
                                        className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-4 px-8 rounded-xl transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 shadow-lg"
                                    >
                                        提交申请
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default DemoProduct;